import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const NewsFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.42 19.84V4.08H18.58V19.84H5.42ZM12.58 7.5V9.34H15.06V7.5H12.58ZM9.02 12.8H10.7V7.58H9.02V12.8ZM12.58 11.04V12.88H15.06V11.04H12.58ZM9.02 14.66V16.34H14.98V14.66H9.02Z" />
    </SvgIcon>
  );
});
